



/* TN: Acordeones de producto -> solo uno abierto y scroll al inicio del seleccionado */
(function () {
  function getHeaderOffset() {
    const sticky = document.querySelector('sticky-header');
    if (sticky) return Math.round(sticky.getBoundingClientRect().height);

    const header = document.querySelector('#shopify-section-header');
    if (header) return Math.round(header.getBoundingClientRect().height);

    const headerEl = document.querySelector('header');
    if (headerEl) return Math.round(headerEl.getBoundingClientRect().height);

    return 0;
  }

  function scrollToSummary(detailsEl) {
    const summary = detailsEl.querySelector('summary');
    if (!summary) return;

    const offset = getHeaderOffset() + 12; // margen extra
    const top = window.scrollY + summary.getBoundingClientRect().top - offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  }

  function bindAccordions(scope) {
    // Dawn/Sense suelen usar <details class="accordion"> dentro de la ficha
    const accordions = scope.querySelectorAll(
      '.product details.accordion, .product__info-container details.accordion, .product__accordion details'
    );

    accordions.forEach((d) => {
      if (d.dataset.tnBound === '1') return;
      d.dataset.tnBound = '1';

      d.addEventListener('toggle', () => {
        if (!d.open) return;

        // Cerrar los demás del mismo bloque de info de producto
        const container =
          d.closest('.product__info-container') ||
          d.closest('.product') ||
          document;

        container.querySelectorAll('details.accordion[open], .product__accordion details[open]').forEach((other) => {
          if (other !== d) other.removeAttribute('open');
        });

        // Esperar a que el DOM recalcule alturas tras cerrar el anterior y abrir el nuevo
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            scrollToSummary(d);
          });
        });
      });
    });
  }

  function init() {
    bindAccordions(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Para el editor de Shopify (cuando recarga secciones)
  document.addEventListener('shopify:section:load', init);
})();






/* =========================================================
   TN - WhatsApp button handler (protocol + fallback)
   ========================================================= */
(() => {
  if (window.__tn_wa_bound) return;
  window.__tn_wa_bound = true;

  const isMobileUA = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  document.addEventListener(
    "click",
    (e) => {
      const a = e.target.closest("a.tn-wa");
      if (!a) return;

      e.preventDefault();

      const phoneRaw = (a.getAttribute("data-wa-phone") || "").replace(/[^\d]/g, "");
      if (!phoneRaw) return;

      // OJO: ya viene codificado desde Liquid con url_encode
      const textEnc = a.getAttribute("data-wa-text") || "";

      const protocolUrl = `whatsapp://send?phone=${phoneRaw}&text=${textEnc}`;
      const fallbackUrl = isMobileUA()
        ? `https://wa.me/${phoneRaw}?text=${textEnc}`
        : `https://web.whatsapp.com/send?phone=${phoneRaw}&text=${textEnc}`;

      let opened = false;
      let timer;

      const markOpened = () => {
        if (opened) return;
        opened = true;
        if (timer) clearTimeout(timer);
        document.removeEventListener("visibilitychange", onVis);
        window.removeEventListener("blur", onBlur);
      };

      const onVis = () => { if (document.hidden) markOpened(); };
      const onBlur = () => markOpened();

      document.addEventListener("visibilitychange", onVis);
      window.addEventListener("blur", onBlur);

      timer = setTimeout(() => {
        if (!opened) window.location.href = fallbackUrl;
      }, 800);

      window.location.href = protocolUrl;
    },
    { passive: false }
  );
})();






/* TN: Reescribir enlaces de PDFs de cdn.shopify.com -> tu dominio /cdn/shop/files/ */
(function () {
  function rewritePdfLinks(scope) {
    const origin = window.location.origin;

    scope.querySelectorAll('a[href*="cdn.shopify.com"][href*="/files/"]').forEach((a) => {
      try {
        const u = new URL(a.href);

        // Coge SIEMPRE el último tramo después de "/files/"
        const parts = u.pathname.split('/files/');
        if (parts.length < 2) return;

        let filename = parts[parts.length - 1]; // <- solo "archivo.pdf"
        filename = filename.replace(/^\/+/, '');

        if (!filename.toLowerCase().endsWith('.pdf')) return;

        // Mantener query (v=...) tal cual
        const newUrl = origin + '/cdn/shop/files/' + filename + u.search;

        a.href = newUrl;
        if (!a.target) a.target = '_blank';
        a.rel = (a.rel ? a.rel + ' ' : '') + 'noopener';
      } catch (e) {}
    });
  }

  function init() {
    rewritePdfLinks(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => rewritePdfLinks(document));
})();

